import { LoadingContainer } from '@/pages/reporting-tools/components/loading-container';

export const MissionListLoading = () => {
  return (
    <div className="w-full">
      <LoadingContainer title="Loading missions..." />
    </div>
  );
};
